'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var n=Object.defineProperty,o=Object.defineProperties;var p=Object.getOwnPropertyDescriptors;var i=Object.getOwnPropertySymbols;var q=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable;var j=(a,b,c)=>b in a?n(a,b,{enumerable:!0,configurable:!0,writable:!0,value:c}):a[b]=c,s=(a,b)=>{for(var c in b||(b={}))q.call(b,c)&&j(a,c,b[c]);if(i)for(var c of i(b))r.call(b,c)&&j(a,c,b[c]);return a},t=(a,b)=>o(a,p(b));var u=(a=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(a,{get:(b,c)=>(typeof require!="undefined"?require:b)[c]}):a)(function(a){if(typeof require!="undefined")return require.apply(this,arguments);throw new Error('Dynamic require of "'+a+'" is not supported')});var k=(a,b,c)=>{if(!b.has(a))throw TypeError("Cannot "+c)};var v=(a,b,c)=>(k(a,b,"read from private field"),c?c.call(a):b.get(a)),w=(a,b,c)=>{if(b.has(a))throw TypeError("Cannot add the same private member more than once");b instanceof WeakSet?b.add(a):b.set(a,c);},x=(a,b,c,e)=>(k(a,b,"write to private field"),e?e.call(a,c):b.set(a,c),c);var y=(a,b,c)=>new Promise((e,h)=>{var l=d=>{try{f(c.next(d));}catch(g){h(g);}},m=d=>{try{f(c.throw(d));}catch(g){h(g);}},f=d=>d.done?e(d.value):Promise.resolve(d.value).then(l,m);f((c=c.apply(a,b)).next());});

exports.a = s;
exports.b = t;
exports.c = u;
exports.d = v;
exports.e = w;
exports.f = x;
exports.g = y;
